import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ProductCalculatorComponent } from '@app/main/product/product-calculator/product-calculator.component';

@Injectable({
  providedIn: 'root',
})
export class CalculatorDialogService {
  private dialogRef: MatDialogRef<ProductCalculatorComponent> | undefined;

  constructor(private dialog: MatDialog) {}

  toggleCalculator(): void {
    const existingDialog = this.findOpenCalculatorDialog();

    if (existingDialog) {
      this.closeCalculator();
    } else {
      this.openCalculator();
    }
  }

  openCalculator(): void {
    if (this.dialogRef && !this.dialog.openDialogs.includes(this.dialogRef)) {
      this.dialogRef = undefined;
    }

    if (this.dialogRef) {
      return;
    }

    const dialogConfig: MatDialogConfig = {
      hasBackdrop: false,
      autoFocus: false,
      width: '850px',
    };

    this.dialogRef = this.dialog.open(ProductCalculatorComponent, dialogConfig);
  }

  closeCalculator(): void {
    const existingDialog = this.findOpenCalculatorDialog();

    if (existingDialog) {
      existingDialog.close();
    }

    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = undefined;
    }
  }

  isCalculatorOpen(): boolean {
    return !!this.findOpenCalculatorDialog();
  }

  private findOpenCalculatorDialog():
    | MatDialogRef<ProductCalculatorComponent>
    | undefined {
    return this.dialog.openDialogs.find(
      (dialog) => dialog.componentInstance instanceof ProductCalculatorComponent
    ) as MatDialogRef<ProductCalculatorComponent> | undefined;
  }
}
